// base
import { createAsyncThunk } from '@reduxjs/toolkit';

// api
import { nationApi } from '../apis/nation.api';

// action
import { actions } from '../actions/nation.action';

// consts
import { ReqCreateNation, ReqUpdateNation, ResNations } from '../models/nation.model';
import { ResultBaseProps } from 'modules/common';

// 국가 목록 조회
export const getNations = createAsyncThunk<ResNations, void>(
  actions.GET_NATION_LIST,
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await nationApi.getNations();

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// 국가 save
export const createNation = createAsyncThunk<ResultBaseProps, ReqCreateNation>(
  actions.CREATE_NATION,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await nationApi.createNation(data);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// 국가 Edit
export const updateNation = createAsyncThunk<ResultBaseProps, ReqUpdateNation>(
  actions.UPDATE_NATION,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await nationApi.updateNation(data);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// 국가 삭제
export const deleteNation = createAsyncThunk<ResultBaseProps, string>(
  actions.DELETE_NATION,
  async (id, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await nationApi.deleteNation(id);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
